(function (global, factory) {
	typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory(require('extend')) :
	typeof define === 'function' && define.amd ? define('watermark', ['extend'], factory) :
	(global.watermark = factory(global.extend));
}(this, (function (extend) { 'use strict';

extend = 'default' in extend ? extend['default'] : extend;

var version = "1.0.3";

/**
 * @module watermark
 * @author xujian1
 * @description 水印工具
 */

var defaultOptions = {
    color: 'rgba(9, 73, 137, 0.08)',
    autoRelative: true,
    zIndex: '9998',
    top: '0',
    left: '0',
    position: 'absolute',
    width: '100%',
    height: '100%',
    padding: {
        right: '0',
        bottom: '0'
    }

    /**
     *
     * @param {string} selector 要加水印的元素选择器
     * @param {string} text 水印内容
     * @param {object} [options={}] - 选项
     * @param {string} [options.color=rgba(150,150,150, 0.3)] - 水印文字颜色
     * @param {boolean} [options.autoRelative=true] - 是否将选择的元素设置为 relative 布局
     * @param {string} [options.zIndex=9999] - 水印 z-index
     * @param {string} [options.top=0]- 水印样式 top
     * @param {string} [options.left=0] - 水印样式 left
     * @param {string} [options.width=100%] - 水印样式 width
     * @param {string} [options.height=100%] - 水印样式 height
     * @param {string} [options.position=absolute] - 水印样式 position
     * @param {object} [options.padding={}] - 水印间隔偏移量
     * @param {string} [options.padding.right=0] - 右侧padding值
     * @param {string} [options.padding.bottom=0] - 底部padding值
     */
};function watermark(selector, text, options) {
    try {
        options = extend({}, defaultOptions, options);
        Array.prototype.forEach.call(document.querySelectorAll(selector), function (el) {

            if (options.autoRelative && window.getComputedStyle(el).position === 'static') {
                el.style.position = 'relative';
            }

            el.style.opacity = options.opacity;
            var mark = document.createElement('div');
            var initStyle = {
                opacity: options.opacity || '',
                position: options.position,
                width: options.width,
                height: options.height,
                top: options.top + 'px',
                left: options.left + 'px',
                zIndex: options.zIndex,
                backgroundRepeat: 'repeat',
                pointerEvents: 'none'
            };

            Object.keys(initStyle).forEach(function (k) {
                mark.style[k] = initStyle[k];
            });

            var canvas = document.createElement('canvas');
            canvas.width = 120 + parseInt(options.padding.right, 10);
            canvas.height = 80 + parseInt(options.padding.bottom, 10);
            var ctx = canvas.getContext('2d');
            ctx.fillStyle = options.color;
            var font = 14;
            ctx.font = font + 'px Arial';
            ctx.translate(6, 80);
            ctx.rotate(-30 / 180 * Math.PI);
            while (ctx.measureText(text).width > (200 - 40) * 1.414) {
                font -= 1;
                ctx.font = font + 'px Arial';
            }
            ctx.fillText(text, 0, 0);
            mark.style.backgroundImage = 'url(' + canvas.toDataURL() + ')'; // mark.style 会对赋值的属性进行格式化, 反向赋值保证双方一致

            initStyle = {};
            Object.keys(mark.style).filter(function (k) {
                return (/^\d+$/.test(k)
                );
            }).forEach(function (k) {
                var propName = mark.style[k].split('-').map(function (s, i) {
                    return (i === 0 ? s.substr(0, 1) : s.substr(0, 1).toUpperCase()) + s.substr(1);
                }).join('');
                initStyle[propName] = mark.style[propName];
            });
            el.appendChild(mark

            // 检测水印被删除 上报
            );var MutationObserver = window.MutationObserver || window.WebKitMutationObserver || window.MozMutationObserver || watermark.MutationObserver;

            if (!MutationObserver) {
                // reportError('水印不支持', {
                //     text: text,
                //     options: options,
                //     notIllegal: true,
                // })
                return;
            }

            var observer = new MutationObserver(function (mutationList) {
                var isInDom = function isInDom(node) {
                    if (!node.parentNode) {
                        return false;
                    }
                    return true;
                };
                if (!isInDom(mark)) {
                    // eslint-disable-next-line no-alert
                    window.alert('存在违规删除水印操作, 您的操作将被上报');
                    location.reload();
                    return;
                }
                var isStyleChanged = function isStyleChanged(mark) {
                    var change = Object.keys(initStyle).filter(function (k) {
                        return mark.style[k] !== initStyle[k];
                    }).length;
                    if (change) {
                        return true;
                    }

                    change = Object.keys(mark.style).filter(function (k) {
                        return (/^\d+$/.test(k)
                        );
                    }).filter(function (k) {
                        var propName = mark.style[k].split('-').map(function (s, i) {
                            return (i === 0 ? s.substr(0, 1) : s.substr(0, 1).toUpperCase()) + s.substr(1);
                        }).join('');
                        return initStyle[propName] !== mark.style[propName];
                    }).length;

                    return !!change;
                };

                var isHidden = function isHidden(mark) {
                    var style = getComputedStyle(mark);
                    return style.transform !== 'none' && style.transform || style.display === 'none' || style.visibility === 'hidden';
                };
                if (isStyleChanged(mark) || isHidden(mark)) {
                    // eslint-disable-next-line no-alert
                    window.alert('存在违规隐藏水印操作, 您的操作将被上报');
                    location.reload();
                }
            });

            // Start observing the target node for configured mutations
            // 监听上两层 dom 变化
            observer.observe(el.parentNode && el.parentNode.parentNode || el.parentNode || el, {
                attributes: true,
                childList: true,
                subtree: true
            });
        });
    } catch (e) {
        // nothing
    }
}

/**
 * 代码版本
 * @type {String} version
 */
watermark.version = version;

return watermark;

})));
